import './Line.css';

const Line = () => (
  <div className="Line" />
);

export default Line;
